import axios from 'axios';

function getAllExports (clientId) {
  return axios.get('api/client/' + clientId + '/exports/');
}

function getSingleExport (clientId, exportIds) {
  return axios.get('api/client/' + clientId + '/exports/' + exportIds);
}

function deleteExports (clientId, exportIds) {
  return axios.delete('api/client/' + clientId + '/exports/delete', {
    params: {
      exportIds: exportIds
    }
  });
}

async function toursExportDownload (payload) {
  return axios({
    method: 'post',
    url: 'api/client/exports/blob/' + payload.exportsId + '/',
    responseType: 'arraybuffer',
    data: payload
  }).catch((error) => {
    console.log(error);
  });
}

export {
  getAllExports,
  getSingleExport,
  deleteExports,
  toursExportDownload
};



// WEBPACK FOOTER //
// ./src/services/ExportsService.js